var _excluded = ["getRowModel", "onRowClick", "getRowAriaLabel", "isLoading", "loadingRowIds", "highlightedRowIds", "mobileRowRenderer", "isHeaderSticky", "sortingState", "getHeaderGroups"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Container, useBreakpoint } from '../../../..';
import { _TableMobileContainer } from '../../../internal';
import { DesktopTable } from './DesktopTable';
import { jsx as _jsx } from "react/jsx-runtime";

var TableComponent = (_ref, ref) => {
  var {
    getRowModel,
    onRowClick,
    getRowAriaLabel,
    isLoading,
    loadingRowIds = [],
    highlightedRowIds = [],
    mobileRowRenderer,
    isHeaderSticky,
    sortingState,
    getHeaderGroups
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var tableProps = {
    getRowModel,
    onRowClick,
    getRowAriaLabel,
    isLoading,
    getHeaderGroups
  };
  return /*#__PURE__*/_jsx(Container, {
    children: isMobile && mobileRowRenderer ? /*#__PURE__*/_jsx(_TableMobileContainer, _objectSpread(_objectSpread({}, tableProps), {}, {
      highlightedRowIds: highlightedRowIds,
      mobileRowRenderer: mobileRowRenderer
    })) : /*#__PURE__*/_jsx(DesktopTable, _objectSpread(_objectSpread({
      ref: ref
    }, tableProps), {}, {
      loadingRowIds: loadingRowIds,
      highlightedRowIds: highlightedRowIds
    }, restProps))
  });
};

export var Table = /*#__PURE__*/React.forwardRef(TableComponent);
Table.displayName = 'Table';
//# sourceMappingURL=Table.js.map